export default __webpack_public_path__ + "static/media/left-mobile-green.2bd34b37.svg";